module.exports = __webpack_public_path__ + "static/media/eye.fe90eaac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/eye.svg
// module id = 65
// module chunks = 3